import { render, staticRenderFns } from "./Kardexxx.vue?vue&type=template&id=19230910&scoped=true"
import script from "./Kardexxx.vue?vue&type=script&lang=js"
export * from "./Kardexxx.vue?vue&type=script&lang=js"
import style0 from "./Kardexxx.vue?vue&type=style&index=0&id=19230910&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "19230910",
  null
  
)

export default component.exports